<template>
  <div>
    <!-- 全屏状态栏 -->
    <div v-if="isInFullscreen" class="status-bar">
      <div class="status-bar-left">
        <span class="time">{{ currentTime }}</span>
        <img class="carrier-icon" src="@/assets/imag/mt.jpg" alt="Carrier Icon">
      </div>
      <div class="status-bar-right">
        <span class=network-speed>{{ networkSpeed }}<br>KB/s</span>
        <img class="carrier-icon" style="height: 15px;" src="@/assets/imag/信号5G.png" alt="Carrier Icon">
        <img class="carrier-icon" src="@/assets/imag/dt_dianliang.png" alt="Carrier Icon">
      </div>
    </div>
    <!-- 使用vant的loading组件 -->
    <van-loading
      v-if="loading"
      type="spinner"
      color="#1989fa"
      vertical
    >
      加载中...
    </van-loading>

    <!-- 错误信息展示 -->
    <van-empty
      v-else-if="error"
      image="error"
      :description="errorMessage"
    >
      <van-button
        round
        type="primary"
        @click="getPxInfo"
      >
        重试
      </van-button>
    </van-empty>
    <div class="training-details-page" v-else>


      <!-- 主要内容区域 -->

      <van-popup v-model="showCenter" round :style="{ width: '90%', height: '300px' }">
        <div class="main-body">
          <div class="ico-header" :class="{ 'error-icon': showError }">
            <van-icon v-if="!showError" name="checked" />
            <div v-else class="error-icon-circle">
              <!-- <van-icon name="warning-o" /> -->
            </div>
          </div>
          <div class="font-content">
            <div v-if="showError" class="error-title">签到失败</div>
            <div :style="showError ? { 'font-size': '15px', 'font-weight': 500 } : {}">{{msg}}</div>
          </div>
          <div class="footer"><van-button round size="large" @click="closeCenterPopup" color="#fed000"><p style="color:black">我知道了</p></van-button></div>
        </div>

      </van-popup>
      <van-popup v-model="showQp" round :style="{ width: '90%', height: '300px' }">
        <div class="main-body">
          <div class="ico-header" style="color: orange;"><van-icon name="info-o" /></div>
          <div class="font-content">{{msg2}}</div>
          <div class="footer"><van-button round size="large" @click="enterFullscreen" color="#fed000"><p style="color:black">去签到</p></van-button></div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
// 1. 引入组件
import { Notify, Toast, Loading } from 'vant';
import { getPxInfo, GenerateQRode } from '@/api/index';
// import QrScanner from './QrScanner.vue';
// import PicPx from '@/view/pic/PicPx.vue';
// import QrScannerNew from './QrScannerNew.vue';

export default {
  name: 'Login',
  // 2. 注册组件
  components: {
    // QrScanner,
    // PicPx
    // QrScannerNew,
  },
  created() {
    // 获取所有查询参数（对象形式）
    const queryParams = this.$route.query;
    const { keyScrent } = this.$route.query;
    const type = this.$route.query.type || 'scan'; // 获取 type 参数，默认为 scan

    // 设置组件类型
    this.componentType = type;

    this.keyScrent = keyScrent;
    if (!keyScrent) {
      this.isHidden = false;
      Notify({ type: 'danger', message: '请求参数错误，请重试！' });
      return;
    }
    this.isHidden = true;
    this.getPxInfo(keyScrent);
    // 连接 WebSocket 并发送页面打开消息
    this.connectWebSocket();
    // 添加时钟更新
    this.updateTime();
    setInterval(this.updateTime, 60000); // 每分钟更新一次时间

    setInterval(this.updateNetworkSpeed, 3000);
    this.updateNetworkSpeed(); // 初始化网络速度
    // console.log('所有查询参数:', queryParams);
    // console.log('所有查询参数:', keyScrent);
    // console.log('组件类型:', type);
  },
  data() {
    return {
      networkSpeed: '0.00', // 网络速度
      loading: true,
      error: false,
      isHidden: true,
      show: false,
      msg: '签到成功',
      msg2: '请参加培训后扫码签到',
      showCenter: false,
      showError: false, // 是否显示错误弹窗
      // 是否全屏
      showQp: true,
      // 3. 添加状态来控制子组件的显隐
      showScanner: false, // 扫码组件显示状态
      showPhoto: false, // 拍照组件显示状态
      componentType: 'scan', // 组件类型：scan 或 pic
      // 时间状态
      currentTime: '',
      // 电池电量
      batteryLevel: 85,
      // 全屏状态
      isInFullscreen: false,
      // 将页面所有动态数据都放在 data 中
      details: {
      },
      keyScrent: '',
      // WebSocket 相关
      ws: null,
      // wsUrl: 'ws://localhost:8080/web-qrcode',
      wsUrl: 'wss://www.amgoto.top:8080/web-qrcode',
    };
  },
  methods: {

    // 判断是否为苹果设备（包括iOS和macOS）
    isAppleDevice() {
      const userAgent = navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod|macintosh/.test(userAgent);
    },

    // 判断是否为iOS设备
    isIOS() {
      const userAgent = navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    },

    // 判断是否为macOS设备
    isMacOS() {
      const userAgent = navigator.userAgent.toLowerCase();
      return /macintosh/.test(userAgent) && !this.isIOS();
    },
    updateNetworkSpeed() {
      // 模拟网络速度更新
      this.networkSpeed = `${Math.floor(Math.random() * 100).toString()}.${Math.floor(Math.random() * 100).toString()}`;
    },
    // 4. 定义方法来打开子组件（扫码或拍照）
    openScanner() {
      if (!this.isHidden) {
        Notify({ type: 'danger', message: '请求参数错误，请重试！' });
        return;
      }
      if (this.show) {
        Notify({ type: 'danger', message: '该链接已超时，请联系管理员！' });
        return;
      }

      // 根据组件类型打开对应的组件
      if (this.componentType === 'pic') {
        this.showPhoto = true;
      } else {
        this.showScanner = true;
      }
    },
    // 更新当前时间
    updateTime() {
      const now = new Date();
      this.currentTime = `${now.getHours().toString().padStart(2, '0')}:${
        now.getMinutes().toString().padStart(2, '0')}`;
    },

    // 模拟电池电量更新
    updateBatteryLevel() {
      // 模拟电池电量在80-95%之间变化
      this.batteryLevel = Math.floor(Math.random() * 16) + 80;
    },
    // 进入全屏
    enterFullscreen() {
      // 如果是苹果设备，则不执行全屏操作
      if (this.isAppleDevice()) {
        // console.log('苹果设备不支持全屏，跳过全屏操作');
        // this.isInFullscreen = true; // 仍然设置状态为全屏，以显示状态栏
        this.showQp = false;
        return;
      }
      this.showQp = false; // 关闭弹框
      const element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) { /* Safari */
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) { /* IE11 */
        element.msRequestFullscreen();
      }
      // 设置全屏状态
      this.isInFullscreen = true;
    },

    // 退出全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) { /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE11 */
        document.msExitFullscreen();
      }
      // 添加: 更新全屏状态
      this.isInFullscreen = false;
    },

    // 检查是否全屏
    isFullscreen() {
      return !!(
        document.fullscreenElement
        || document.webkitFullscreenElement
        || document.msFullscreenElement
      );
    },

    // 切换全屏
    toggleFullscreen() {
      if (this.isFullscreen()) {
        this.exitFullscreen();
      } else {
        this.enterFullscreen();
      }
    },
    // 校验
    isValid32CharLowerHexString(str) {
      // 允许数字、字母和下划线，长度不超过200
      return /^[0-9a-zA-Z_]{1,200}$/.test(str);
    },
    async getPxInfo(keyScrent) {
      this.loading = true;
      this.error = false;
      try {
        const response = await getPxInfo(keyScrent);
        if (response.code === 500) {
          Toast.fail(response.msg);
          this.show = true;
          this.error = true;
          this.errorMessage = response.msg;
          return;
        } if (response.code === 200) {
          this.details = response.data;
          this.show = false;
        }
      } catch (err) {
        // 请求出错（如500错误）
        const errorMsg = '服务器错误';
        this.error = true;
        this.errorMessage = errorMsg;
      } finally {
        this.loading = false;
      }
    },

    // 5. 定义处理扫描成功事件的方法
    handleScanSuccess(qrCodeData) {
      // qrCodeData 就是从二维码中解析出的文字标识
      // console.log('扫描到的标识:', qrCodeData);
      if (this.isValid32CharLowerHexString(qrCodeData)) {
        // 后台接口
        this.details.pxUuid = qrCodeData;
        GenerateQRode(this.details).then((response) => {
          //  console.log(response)
          // 签到成功
          if (response.code === 200) {
            this.showCenter = true;
          } else {
            Toast.fail(response.msg);
          }
        });
      } else {
        Toast.fail('签到码错误，请扫描正确的签到码！');
      }
    },
    handleNewSuccess(qrCodeData, count, isExpiring) {
      // qrCodeData 就是从二维码中解析出的文字标识
      // isExpiring: 二维码是否即将失效（剩余时间<5秒）
      // console.log('扫描到的标识:', qrCodeData, '是否即将失效:', isExpiring);
      this.showPhoto = false;
      if (this.isValid32CharLowerHexString(qrCodeData)) {
        // 后台接口
        this.details.pxUuid = qrCodeData;
        GenerateQRode(this.details).then((response) => {
          //  console.log(response)
          // 签到成功
          if (response.code === 200) {
            // 如果二维码即将失效，显示失败弹窗
            if (isExpiring) {
              this.showError = true;
              this.msg = '扫码失败，二维码已失效，请重新扫码';
              this.showCenter = true;
            } else {
              // 正常情况显示成功弹窗
              this.showError = false;
              this.msg = '签到成功';
              this.showCenter = true;
            }
          } else {
            Toast.fail(response.msg);
          }
        });
      } else {
        Toast.fail('签到码错误，请扫描正确的签到码！');
      }
    },
    // 二维码失效过期
    scanExpired() {
      this.showPhoto = false;
      this.showError = true;
      this.msg = '扫码失败，二维码已失效，请重新扫码';
      this.showCenter = true;
    },
    // 6. 定义处理拍照成功事件的方法
    handlePhotoSuccess(photoData) {
      // photoData 是后台返回的照片信息
      // console.log('拍照上传成功:', photoData);
      this.showCenter = true;
      // 可以根据需要进行后续处理，比如保存照片URL等
      // 这里可以和扫码一样，调用签到接口
      // this.details.photoUrl = photoData.url;
      // GenerateQRode(this.details).then(response => { ... });
    },

    // WebSocket 相关方法
    connectWebSocket() {
      this.cleanupWebSocket();

      try {
        let url = this.wsUrl;
        if (this.keyScrent) {
          const param = `clientId=${encodeURIComponent(this.keyScrent)}`;
          url += (url.indexOf('?') === -1 ? '?' : '&') + param;
        }
        this.ws = new WebSocket(url);

        this.ws.onopen = () => {
          // console.log('✅ 页面 WebSocket 连接成功');
          // 连接成功后发送页面打开消息
          if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            const msg = {
              type: 'control',
              controlType: 'BROADCAST_SCAN_COUNT',
              clientId: this.keyScrent,
              message: '即将扫码，请准备！！！',
            };
            this.ws.send(JSON.stringify(msg));
            // console.log('📤 发送页面打开消息');
          }
        };

        this.ws.onmessage = (event) => {
          // console.log('📨 页面 WebSocket 收到消息:', event.data);
        };

        this.ws.onerror = (error) => {
          console.error('❌ 页面 WebSocket 错误:', error);
        };

        this.ws.onclose = () => {
          // console.log('🔌 页面 WebSocket 连接关闭');
        };
      } catch (e) {
        // console.error('💥 页面 WebSocket 连接异常:', e);
      }
    },

    cleanupWebSocket() {
      if (this.ws) {
        try {
          this.ws.close();
        } catch (e) {}
        this.ws = null;
      }
    },

    // 发送 WebSocket 消息的方法（供子组件调用）
    sendWebSocketMessage(message) {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        try {
          const msg = {
            type: 'control',
            controlType: 'BROADCAST_SCAN_COUNT',
            clientId: this.keyScrent,
            message,
          };
          this.ws.send(JSON.stringify(msg));
          // console.log('📤 父组件发送消息:', message);
        } catch (e) {
          // console.warn('发送消息失败:', e);
        }
      } else {
        console.warn('WebSocket 未连接，无法发送消息');
      }
    },

    // 关闭弹窗
    closeCenterPopup() {
      // 先关闭弹窗
      this.showCenter = false;
      // 延迟重置状态，避免出现短暂的成功标识
      setTimeout(() => {
        this.showError = false;
        this.msg = '签到成功'; // 重置消息
      }, 300);
    },

    // 测试方法：模拟成功情况
    testSuccess() {
      // 模拟一个有效的二维码数据
      const testQrCode = `d_riYUdw_${Date.now()}_1206752`;
      const testCount = 20; // 模拟扫码次数大于19
      const isExpiring = false;
      // console.log('🧪 测试成功接口弹窗');
      if (this.isValid32CharLowerHexString(testQrCode)) {
        // 真实流程，走handleNewSuccess（会自动调接口并正常展示倒计时、弹窗等）
        this.handleNewSuccess(testQrCode, testCount, isExpiring);
      } else {
        Toast.fail('签到码错误，请扫描正确的签到码！');
      }
    },

    // 测试方法：模拟即将失效情况
    testExpiring() {
      // 模拟一个即将失效的二维码（生成时间是15秒前，剩余时间只有5秒）
      const expiredTime = Date.now() - 15000; // 15秒前生成
      const testQrCode = `d_riYUdw_${expiredTime}_1206752`;
      // 模拟扫码次数大于19
      const testCount = 20;
      // 模拟即将失效（isExpiring = true）
      const isExpiring = true;

      // console.log('🧪 测试失效弹窗');

      // 直接模拟接口成功的情况，避免实际调用接口
      if (this.isValid32CharLowerHexString(testQrCode)) {
        // 模拟接口返回成功
        // 如果二维码即将失效，显示失败弹窗
        if (isExpiring) {
          this.showError = true;
          this.msg = '扫码失败，二维码已失效，请重新扫码';
          this.showCenter = true;
        } else {
          // 正常情况显示成功弹窗
          this.showError = false;
          this.msg = '签到成功';
          this.showCenter = true;
        }
      } else {
        Toast.fail('签到码错误，请扫描正确的签到码！');
      }
    },
  },
  beforeDestroy() {
    // 页面销毁时清理 WebSocket 连接
    this.cleanupWebSocket();
  },
};
</script>

<style scoped lang='less'>
/* 添加状态栏样式 */
.status-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: #757575;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  font-size: 12px;
  color: #fff;
  z-index: 9999;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.status-bar-left {
  display: flex;
  align-items: center;
}

.status-bar-left .carrier-icon {
  width: 15px;
  height: auto;
  margin-left: 5px;
  border-radius: 3px;
}
.status-bar-right .carrier-icon {
  width: 24px;
  height: auto;
  margin-left: 5px;
}

.signal-strength {
  display: flex;
  margin-right: 5px;
}

.signal-bar {
  width: 2px;
  height: 8px;
  background-color: #999;
  margin-right: 1px;
}

.signal-bar.full {
  background-color: #FFF;
  height: 14px;
}

.signal-bar.half {
  background-color: #FFF;
  height: 7px;
  margin-top: 7px;
}

.carrier {
  margin-left: 5px;
}

.status-bar-center .time {
  font-weight: 500;
}

.status-bar-right {
  display: flex;
  align-items: center;
  .network-speed {
    font-size: 8px;
    color: #fff;
  }
}

.battery {
  display: flex;
  align-items: center;
  border: 1px solid #000;
  padding: 1px;
  width: 24px;
  height: 12px;
  position: relative;
}

.battery-level {
  height: 100%;
  background-color: #000;
}

.battery-text {
  margin-left: 5px;
}
/* 基础重置和全局样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.error-message {
  color: #ee0a24;
  margin-top: 10px;
}
.main-body{
  width: 100%;
  height: 100%;
  position: relative;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
.footer{
  //  position: absolute;
  width: 90%;
  //  bottom: 20px;
}
.font-content{
  font-size: 20px;
  font-weight: bold;
  display: contents;
}
.ico-header{
  // position: absolute;
  // top: 30px;
  color: #00ab5c;
  font-size: 4rem;
}

.ico-header.error-icon {
  color: #ee0a24;
}

.error-icon-circle {
  width: 60px;
  height: 60px;
  /* 移除圆角和背景色 */
  /* border-radius: 50%; */
  /* background-color: #ee0a24; */

  /* 添加背景图片 */
  background-image: url('@/assets/imag/感叹号.png');
  background-size: cover;      /* 确保图片覆盖整个区域 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 不重复 */

  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.error-icon-circle .van-icon {
  color: #fff;
  font-size: 3rem;
}

.error-title {
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 10px;
}
/* 页面容器，模拟手机屏幕 */
.training-details-page {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  background-color: #eeeeee; /* 页面整体为白色背景 */
  color: #333;
  /* 2. 移除固定高度，让页面自适应内容高度 */
  min-height: 100vh; /* 确保内容少时页面也能铺满屏幕 */
  width: 100%;
  max-width: 480px; /* 在PC上模拟手机宽度 */
  margin: 0 auto; /* 在PC上居中显示 */
  //   padding: 20px 16px; /* 为页面内容提供内边距 */
}

/* 顶部标题栏 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0; /* 防止标题栏被压缩 */
  position: relative;
  height: 50px;
}

// 添加: 当有状态栏时，header需要下移
.header.with-status-bar {
  margin-top: 40px;
}

.header-title {
  font-size: 1rem;
  font-weight: 600;
  color: #000;
  /* 绝对定位实现完美居中 */
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.back-icon-container {
  color: #333;
}
.back-icon {
  width: 20px;
  height: 20px;
}

.header-action {
  font-size: 14px;
  color: #333;
}

/* 主要内容区域 */
.content {
  flex-grow: 1; /* 占据剩余的所有空间 */
  //   overflow-y: auto; /* 内容超出时可以滚动 */
  background-color: #fff; /* 内容区域为白色背景 */
  //   padding: 0 16px;
  /* 为固定的底部按钮留出空间 */
  //   padding-bottom: 120px;
}

.main-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #000;
  margin-top: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  border-bottom: 1px solid #f0f0f0;
}

/* 信息区块 */
.info-section {
  padding: 15px 8px;
  //   border-bottom: 1px solid #f0f0f0;
}
.info-section:last-of-type {
  border-bottom: none;
}

.section-title {
  font-size: 0.88rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.info-item {
  display: flex;
  font-size: 0.85rem;
  line-height: 1.6;
  margin-bottom: 8px;
}

.label {
  color: #333;
  min-width: 70px;
  flex-shrink: 0; /* 防止标签被压缩 */
  //   margin-right: 5px;
}

.value {
  color: #333;
  //   margin-left: 10px
}

.contact-person {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.contact-link {
  display: flex;
  align-items: center;
  color: #3182CE; /* 蓝色链接 */
  text-decoration: none;
  font-size: 0.9rem;
  margin-left: 12px;
}

.phone-icon {
  margin-right: 4px;
}

.section-content {
  font-size: 0.8rem;
  line-height: 1.3; /* 增加行高，提升可读性 */
  color: #a8a7a7;
}

</style>
